import type { ClassValue } from 'clsx'
import type { CSSProperties } from 'react'

import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

// Inline CSS custom properties, e.g. style={cssVars({ '--d': '0.2s' })}.
export function cssVars(vars: Record<`--${string}`, string | number>): CSSProperties {
    return vars as CSSProperties
}